import { TFunction } from 'i18next';
import * as Yup from 'yup';

export type Files = File | null;

export function AddWorkspaceUserSchema(
  t: TFunction<'settings/team', undefined>,
) {
  return Yup.object({
    firstName: Yup.string()
      .trim()
      .required('Nombre requerido')
      .max(32, 'El nombre debe tener como máximo 32 caracteres'),
    email: Yup.string()
      .required('El correo es requerido')
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        t('page.form.validation.email.invalid'),
      ),
    role: Yup.object({
      value: Yup.string().required('El rol es requerido'),
      label: Yup.string().required('El rol es requerido'),
    }),
  });
}

export const EditUserSchema = Yup.object({
  role: Yup.object({
    value: Yup.string().required('El rol es requerido'),
    label: Yup.string().required('El rol es requerido'),
  }),
  pipes: Yup.array()
    .min(1, 'El usuario debe tener acceso a al menos un embudo')
    .required('El usuario debe tener acceso a al menos un embudo'),
  goal: Yup.number()
    .max(999999999999999, 'El objetivo debe ser menor a 999,999,999,999,999')
    .min(0, 'El objetivo debe ser mayor a 0'),
});

export const DeleteUserSchema = Yup.object({
  newRecipientUser: Yup.object({
    value: Yup.string().required('El usuario es requerido'),
    label: Yup.string().required('El usuario es requerido'),
  }),
});
